import { render, staticRenderFns } from "./BuildingOrderModal.vue?vue&type=template&id=392bd9a7&"
import script from "./BuildingOrderModal.vue?vue&type=script&lang=ts&"
export * from "./BuildingOrderModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports